var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mobile-container",
    [
      _c(
        "MobileHeader",
        { attrs: { slot: "header", "nav-action": "home" }, slot: "header" },
        [_vm._v("\n    Burger Boss\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.locationList },
        [
          _c("v-autocomplete", {
            class: _vm.$style.citiesSearch,
            attrs: {
              items: _vm.rests,
              "search-input": _vm.searchParam,
              "append-icon": "",
              "hide-no-data": "",
              "hide-details": "",
              label: "ZIP or City",
              color: "#38AA3F",
              "item-text": "city"
            },
            on: {
              "update:searchInput": function($event) {
                _vm.searchParam = $event
              },
              "update:search-input": function($event) {
                _vm.searchParam = $event
              },
              input: _vm.changeSearch
            }
          }),
          _vm._v(" "),
          _vm.rests.length === 0
            ? _c(
                "div",
                { class: _vm.$style.loadingContainer },
                [_c("LoadingSpinner")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "VList",
            { class: _vm.$style.storesList },
            _vm._l(_vm.filteredRests, function(store) {
              return _c(
                "VListTile",
                {
                  key: store.id,
                  class: _vm.$style.storesListItem,
                  attrs: { ripple: "" },
                  on: {
                    click: function($event) {
                      return _vm.goToLocation(store.id)
                    }
                  }
                },
                [
                  _c("div", { class: _vm.$style.storesListItemContent }, [
                    _c("div", { class: _vm.$style.storeInfo }, [
                      _c("h4", [_vm._v(_vm._s(store.city))]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(store.address) + " ")]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.formatPhone(store.phone)))])
                    ]),
                    _vm._v(" "),
                    _c("div", { class: _vm.$style.storeButtons }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.formatDistance(store.distance)))
                      ])
                    ])
                  ])
                ]
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobileLocationList.vue?vue&type=template&id=8e314c96&
// module id = null
// module chunks = 